
import { mapState, mapGetters, mapActions } from 'vuex';
import ReviewResourceView from '@/mixins/ReviewResourceView';

export default {
  i18nComponentKey: 'WidgetProductReviewsHorizontalScroll.components.HorizontalScroll',
  name: 'HorizontalScroll',
  mixins: [ReviewResourceView],
  props: {
    cols: { type: Number, required: true }
  },
  data() {
    return {
      minPanelWidthPc: 100,
      pcGap: 20
    };
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('widget', ['isMobile']),
    ...mapGetters('widget', [
      'appHeaderShowable',
      'device',
      'headerSectionShowable',
      'showFilterSection',
      'thumbnailShape'
    ]),
    carouselProps() {
      return {
        cols: this.cols,
        panelsPerView: this.isMobile ? this.cols + 0.2 : this.cols,
        minCarouselWidth:
          this.device === 'pc'
            ? this.minPanelWidthPc * this.cols + this.pcGap * (this.cols - 1)
            : 0,
        autoPlay: this.widget.horizontal_scroll_enable_autoscroll,
        delay: this.widget.horizontal_scroll_autoscroll_delay,
        ...this.paginationOptions
      };
    },
    paginationOptions() {
      return {
        showPagination: !this.isMobile,
        paginationOnTop: !this.isMobile,
        paginateByPanel: false,
        totalCount: this.reviews.length
      };
    },
    contentsStyle() {
      return {
        '--min-height': this.showFilterSection ? '204px' : 'auto'
      };
    },
    carouselKey() {
      return this.reviews.map(review => review.id).join('-');
    }
  },
  methods: {
    ...mapActions('widget', ['openReviewPopup']),
    submit(params) {
      this.searchResource(params);
    }
  }
};
